import React from 'react';
import { Button } from 'semantic-ui-react';
import AiSearchInfoLabel from './AiSearchInfoLabel';
import SearchTotalResults from './SearchTotalResults';

const AiSearchBanner = ({ datasetCount, searchStatus }) => (
  <Button
    as="div"
    className="aridhia-search-banner"
    labelPosition="right"
    size="mini"
  >
    <SearchTotalResults datasetCount={datasetCount} searchStatus={searchStatus} />
    <AiSearchInfoLabel />
  </Button>
);

export default AiSearchBanner;
